import React from 'react'
import clsx from 'clsx'

import useIsOrderRoute from '../../../../app/hooks/useIsOrderRoute'
import useChangeLanguage from '../../../../app/hooks/useChangeLanguage'

import NavLanguageMenu from './NavLanguageMenu'
import styles from './NavLanguageSwitcher.module.scss'

export default function NavLanguageSwitcher() {
  const isOrderRoute = useIsOrderRoute()

  const { language, changeLanguage } = useChangeLanguage()

  return (
    <div
      className={clsx(styles.localeSwitchContainer, {
        [styles.isOrderPage]: isOrderRoute,
      })}
    >
      <NavLanguageMenu language={language} onChange={changeLanguage} />
    </div>
  )
}
